import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";

const getMovementName = (movement, filter) => {
  if (["squat", "bench", "deadlift"].includes(filter)) {
    return `${movement} (${filter.charAt(0).toUpperCase() + filter.slice(1)})`;
  }
  return movement;
};

const CatalogList = ({
  filter,
  filteredExercises,
  selectedExercises,
  handleSelect,
  handleDeselect,
  mobile,
  search,
  onChangeFn,
}) => {
  const filterToShow = filter ? filter.toLowerCase() : "";

  return (
    <div className="catalog-list">
      <header className="mobile-hidden">
        <input
          type="search"
          className="text-input search-exercise"
          name="search"
          placeholder="Search Exercise Here..."
          value={search}
          onChange={onChangeFn}
          autoComplete="off"
        />
        {!mobile && (
          <p className="p4">
            Select variations of {filterToShow} to add to your master exercise
            library
          </p>
        )}
      </header>
      {!filteredExercises.length && (
        <p className="s1 text-center">No exercises have been found</p>
      )}
      {filteredExercises.length > 0 && (
        <ul>
          {filteredExercises.map((exercise) => {
            const { _id, movement, primary } = exercise;
            const selected = selectedExercises[primary].find(
              (ex) => ex._id === _id
            );
            return (
              <li
                key={_id}
                onClick={() => {
                  if (selected) {
                    handleDeselect(selected);
                  } else {
                    handleSelect(exercise);
                  }
                }}
              >
                <SvgIcon
                  src={
                    selected
                      ? "/img/new-icons/checked-square.svg"
                      : "/img/new-icons/add-square.svg"
                  }
                  alt={selected ? "deselect" : "select"}
                  noFilterOnLight={selected ? true : false}
                />
                {getMovementName(movement, filter)}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default CatalogList;
